__turbopack_context__.v({
  "className": "geist_mono_f6b2180d-module__WJnSAq__className",
  "variable": "geist_mono_f6b2180d-module__WJnSAq__variable",
});
